import React from 'react';
import SEO from '@/SEO';

const HTML_CONTENT = `<h1>ப்ரஸவ புண்யாஹம்</h1>
  <mat-accordion>
    <mat-expansion-panel>
    <mat-expansion-panel-header>தேவையான சாமான்கள்
      </mat-expansion-panel-header>
      <div class="div3">
        <ion-row>
          <ion-col size="8">மஞ்சள்பொடி </ion-col><ion-col size="4">50 கிராம்</ion-col>
        </ion-row>
        <ion-row>
          <ion-col size="8">குங்குமம்</ion-col><ion-col size="4">1 பாக்கட்</ion-col>
        </ion-row>
        <ion-row>
          <ion-col size="8">மஞ்ச கிழங்கு</ion-col><ion-col size="4">50 கிராம்</ion-col>
        </ion-row>
        <ion-row>
          <ion-col size="8">மாவிலைக்கொத்து</ion-col><ion-col size="4">கொஞ்சம்</ion-col>
        </ion-row>
        <ion-row>
          <ion-col size="8">வெத்திலை</ion-col><ion-col size="4">1 கவுளி</ion-col>
        </ion-row>
        <ion-row>
          <ion-col size="8">பாக்கு</ion-col><ion-col size="4">50 கிராம்</ion-col>
        </ion-row>
        <ion-row>
          <ion-col size="8">பழம்</ion-col><ion-col size="4">2 டஜன்</ion-col>
        </ion-row>
        <ion-row>
          <ion-col size="8">புஷ்பம்</ion-col><ion-col size="4">6 முழம்</ion-col>
        </ion-row>
        <ion-row>
          <ion-col size="8">கும்ப வஸ்த்ரம்</ion-col><ion-col size="4">டவல் -1</ion-col>
        </ion-row>
        <ion-row>
          <ion-col size="8">வாசனை சந்தனம்</ion-col><ion-col size="4">1 டப்பா</ion-col>
        </ion-row>
        <ion-row>
          <ion-col size="8">ஊதுபத்தி</ion-col><ion-col size="4">1 பாக்கட்</ion-col>
        </ion-row>
        <ion-row>
          <ion-col size="8">தேங்காய்கள்</ion-col><ion-col size="4">4</ion-col>
        </ion-row>
        <ion-row>
          <ion-col size="8">வாழை நுனி இலை</ion-col><ion-col size="4">4</ion-col>
        </ion-row>
        <ion-row>
          <ion-col size="8">நெல்</ion-col><ion-col size="4">3 கிலோ</ion-col>
        </ion-row>
        <ion-row>
          <ion-col size="8">அரிசி </ion-col><ion-col size="4">2 கிலோ</ion-col>
        </ion-row>
        <ion-row>
          <ion-col size="8">விரைதானம் விநியோகிக்க</ion-col><ion-col size="4">பாக்கட்டுகள்</ion-col>
        </ion-row>
        <ion-row>
          <ion-col size="8">மணைகள் </ion-col><ion-col size="4">2</ion-col>
        </ion-row>
        <ion-row>
          <ion-col size="8">குத்து விளக்கு </ion-col><ion-col size="4">2</ion-col>
        </ion-row>
        <ion-row>
          <ion-col size="8">சொம்பு, ஸ்தாலி, டம்ளர்</ion-col><ion-col size="4">வெள்ளி</ion-col>
        </ion-row>
        <ion-row>
          <ion-col > எண்ணை, திரிநூல், தீப்பெட்டி, கோலமாவு, ஹாரத்தி இத்யாதிகள் </ion-col>
        </ion-row>
        </div>
        </mat-expansion-panel>
        <mat-expansion-panel>
          <mat-expansion-panel-header>
            </mat-expansion-panel-header>
            <div class="div3">
              </div>
              </mat-expansion-panel>
              <mat-expansion-panel>
                <mat-expansion-panel-header>
                  </mat-expansion-panel-header>
                  <div class="div3">
                    </div>
                    </mat-expansion-panel>
                    <mat-expansion-panel>
                      <mat-expansion-panel-header>
                        </mat-expansion-panel-header>
                        <div class="div3">
                          </div>
                          </mat-expansion-panel>
</mat-accordion>
  <div class="div3" >

{{data[0].l1}}<hr class="orange">
{{data[0].l2}}<hr class="orange">
{{data[0].l3}}<hr class="orange">
{{data[0].l4}}<hr class="orange">
{{data[0].l5}}<hr class="orange">
{{data[0].l6}}
  
  </div>`;

const PrashavaPunyaahamPage = () => {
  return (
    <div className="vaideekam-page-container w-full max-w-4xl mx-auto p-4 md:p-6 pb-24">
      <SEO title="ப்ரஸவ புண்யாஹம் - Ahobilam" />
      <div 
        className="vaideekam-content bg-white p-6 rounded-xl shadow-sm border border-green-100/50"
        dangerouslySetInnerHTML={{ __html: HTML_CONTENT }} 
      />
    </div>
  );
};

export default PrashavaPunyaahamPage;
